import { useQuery } from 'react-query';
import {
  getPayLetterCardBlocklist,
  type GetPayLetterCardBlocklistResponse
} from '../../services/paymentService';

export function useGetPayLetterCardBlocklist() {
  return useQuery<GetPayLetterCardBlocklistResponse, Error>(
    ['payLetterCardBlocklist'],
    () => getPayLetterCardBlocklist(),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
